module.exports = __webpack_public_path__ + "img/cw_ys_shouKuanHeXiao.e52792d4.svg";